import { ADMIN_NAV } from "@/pages/admin/nav";

// O menu é SEMPRE derivado do papel do utilizador autenticado (nunca dos dados do cliente aberto).
export const SUPERVISOR_NAV = [
  { to: "/manager", label: "Clientes", icon: "users", testId: "nav-supervisor-clients" },
  { to: "/inbox", label: "Mensagens", icon: "chat", testId: "nav-supervisor-inbox" },
  { to: "/security", label: "Segurança", icon: "shield", testId: "nav-security" },
];

export const MANAGER_NAV = [
  { to: "/manager", label: "Meus clientes", icon: "users", testId: "nav-manager-clients" },
  { to: "/inbox", label: "Mensagens", icon: "chat", testId: "nav-manager-inbox" },
  { to: "/security", label: "Segurança", icon: "shield", testId: "nav-security" },
];

export const AGENT_NAV = [
  { to: "/manager", label: "Meus clientes", icon: "users", testId: "nav-agent-clients" },
  { to: "/inbox", label: "Mensagens", icon: "chat", testId: "nav-agent-inbox" },
  { to: "/security", label: "Segurança", icon: "shield", testId: "nav-security" },
];

export const CLIENT_NAV = [
  { to: "/dashboard", label: "Terminal", icon: "dashboard", testId: "nav-client-terminal" },
  { to: "/support", label: "Suporte", icon: "chat", testId: "nav-client-support" },
  { to: "/security", label: "Segurança", icon: "shield", testId: "nav-security" },
];

export const ROLE_LABEL = {
  admin: "Administrador",
  supervisor: "Supervisor",
  manager: "Gestor",
  agent: "Agente Plus",
  user: "Cliente",
};

export const navForRole = (role) => {
  if (role === "admin") return ADMIN_NAV;
  if (role === "supervisor") return SUPERVISOR_NAV;
  if (role === "manager") return MANAGER_NAV;
  if (role === "agent") return AGENT_NAV;
  return CLIENT_NAV;
};
